import { FieldActivityTypesSeeding } from './fieldActivityTypesSeeding';

export const FieldActivityTypes = {
  defending: {},
  ditch_cleaning_and_maintenance: {},
  drilling: {},
  extirpation: {},
  feeding: {},
  grafting: {},
  harrowing: {},
  harvesting: {},
  irrigating: {},
  leveling: {},
  milling: {},
  minimum_tillage: {},
  mulching_sheets_laying: {},
  observation: {},
  operation: {},
  other: {},
  pruning: {},
  pruning_residues_removing: {},
  reaping: {},
  replanting: {},
  rolling: {},
  seeding: FieldActivityTypesSeeding,
  shredding: {},
  soil_ripping: {},
  tilling: {},
  transplantation: {},
  leaf_thinning: {},
  ground_processing: {},
  mechanical_weeding: {},
  tying_shoots: {},
  winter_pruning: {},
  green_pruning: {},
  tamping: {},
  ridging: {},
  wire_arrangement: {},
  excerpt_sarment: {},
  inter_row_grass_cutting: {},
  sparing_shears: {},
  swathe: {},
  haying: {},
  raking: {},
  digging: {},
  hoeing: {},
  fire_weeding: {},
  trenched: {},
  hydraulic_soil_arrangement: {},
  suckering: {},
  drawing_up_irrigation_hoses: {},
  hail_rain_prevention_systems_installation: {},
  laying_cover_sheets: {},
  grubbing: {},
  fruit_thinning: {},
  scrub_clearance: {},
  stone_clearing: {},
  deforestation: {},
  deep_plowing: {},
  tillage: {},
  stump_removal: {},
  drainage_laying: {},
  slicing: {},
  laser_leveling: {},
  shoots_topping: {},
  ground_mulching: {},
  weeding: {},
  convexing: {},
  false_sowing: {},
  permitration: {},
  hole_digging: {},
  logging: {},
  failed_plants_replacement: {},
  mulch_ring: {},
  drying: {},
  seeding_feeding: {},
  transplantation_feeding: {},
  irrigation_logistics: {},
  training: {},
  material_transport: {},
  loads: {},
  staff_logistics: {},
  material_movement: {},
  farm_cleaning: {},
  stable_cleaning: {},
  cattle_feeding: {},
  animal_bedding: {},
  cattle_movement: {},
  cattle_helthcare: {},
  manure_movement: {},
  trimming: {},
  greenhouse_covering: {},
  greenhouse_opening: {},
  greenhouse_closure: {},
  maintenance: {},
  tracing: {},
  hose_collection: {},
  pruning_manual: {},
  harvesting_manual: {},
  defending_feeding: {},
  defending_feeding_seeding: {},
  defending_feeding_transplantation: {},
  seeding_defending: {},
  weeding_feeding: {},
  tamping_feeding: {},
  thinning_shoots: {},
  flower_thinning: {},
  pollination: {},
  field_submersion: {},
  gauge_growth: {},
  seeding_harrowing: {},
  non_chemical_protection: {},
  phytosanitary_residue_analysis: {},
  refinement: {},
  weed_removal: {},
  crop_residues_collection: {},
  green_manure: {},
  cleaning_collection_leaves: {},
  establishment_maintenance_lawn: {},
  shaping_trimming_hedges: {},
  restoration_plant_verticality: {},
  renewal_plant_ties: {},
  maintenance_pathways: {},
  removal_dead_plants: {},
  renewal_hedges_borders: {},
  defending_transplantation: {},
  debudding: {},
  lifting: {},
  pre_pruning: {},
  electrical_weeding: {},
  green_harvest: {},
  powdering: {},
  washing: {},
  strip_till: {},
};
